/** The first letters of the sponsor's first and last names, `MH` for Maximilian von
 *  Hohenberg-Schwarzenfeld. */
export const getSponsorInitials = (name: string) => {
  const words = name.trim().split(/\s+/).filter(Boolean)

  if (!words.length) {
    return ''
  }

  return `${words[0][0]}${words.length > 1 ? words[words.length - 1][0] : ''}`.toUpperCase()
}
